import React from 'react';
import Header from '../../../../components/layout/headers/Header';
import DynamicNavigation from "../../../../components/layout/navigation/DynamicNavigation";
import ProductsTable from './ProductList.jsx';

const Loans = () => {
    return (
        <>
            <Header/>
            <DynamicNavigation/>
            <div className="content-body">
                <div className="w-full px-4">
                    <ProductsTable/>
                </div>
            </div>
        </>
    );
};

export default Loans;
